import { useEffect, useState } from 'react';

const VISIBLE_HEIGHT_RATIO = 0.92;

export interface VisualViewportFit {
  maxHeight?: number;
  offsetY: number;
}

const UNCONSTRAINED_FIT: VisualViewportFit = { offsetY: 0 };

export const useVisualViewportFit = (enabled: boolean): VisualViewportFit => {
  const [fit, setFit] = useState<VisualViewportFit>(UNCONSTRAINED_FIT);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!enabled || !viewport) return undefined;

    const measure = () =>
      setFit({
        maxHeight: viewport.height * VISIBLE_HEIGHT_RATIO,
        offsetY: viewport.offsetTop + viewport.height / 2 - window.innerHeight / 2,
      });

    measure();
    viewport.addEventListener('resize', measure);
    viewport.addEventListener('scroll', measure);

    return () => {
      viewport.removeEventListener('resize', measure);
      viewport.removeEventListener('scroll', measure);
      setFit(UNCONSTRAINED_FIT);
    };
  }, [enabled]);

  return fit;
};
